<md-dialog [includePadding]="false">
	<div md-dialog-header>
		<md-icon icon="untitled-ui/education/calculator"></md-icon>
		<span class="md-text-lg-semibold">Semester Project Grades</span>
	</div>

	<div class="body">
		<div class="body__left">
			@for (step of stepperSteps(); track step.id) {
				<md-stepper-step
					[step]="step"
					[isActive]="missingGrades().length > 0 && step.id === currentCriteriaID()"
					[isComplete]="criteriaGrades()[step.id] !== null && criteriaGrades()[step.id] !== undefined"
					[isLastStep]="$last"
					[clickable]="true"
					orientation="vertical"
					(onStepClick)="onStepClicked($event)"
				>
				</md-stepper-step>
			}

			<md-content-box>
				<div>
					<span>Project Grade</span>

					@if (finalGrade(); as grade) {
						<lb-grade-tag [grade]="grade.gradeName" [type]="grade.color ?? 'default'"></lb-grade-tag>
					} @else {
						<lb-grade-tag grade=" A+ / F" type="disabled"></lb-grade-tag>
					}
				</div>
			</md-content-box>
		</div>
		<lb-divider orientation="vertical"></lb-divider>
		<div class="body__right">
			<div class="right-header">
				<md-header size="xs">{{ currentCriteria()?.criteriaName }}</md-header>
				<button md-button [disabled]="!canGoPrevious()" (click)="goPrevious()">Previous</button>
				<span>Criterion {{ currentCriteriaIndex() + 1 }} of {{ projectCriteria().length }}</span>
				<button md-button [disabled]="!canGoNext()" (click)="goNext()">Next</button>
			</div>
			<div class="rubrics">
				@if (currentCriteria(); as criteria) {
					@for (rubric of criteria.rubrics; track rubric.rubricID) {
						<div
							class="rubric-section"
							[ngClass]="{ 'active-section': criteriaGrades()[criteria.criteriaID] === rubric.gradeID }"
							(click)="onRubricChanged(criteria.criteriaID, rubric.gradeID)"
						>
							@if (criteriaGrades()[criteria.criteriaID] === rubric.gradeID && rubric.gradeName !== 'F') {
								<md-button-group
									orientation="vertical"
									[value]="getModifierForCriteria(criteria.criteriaID)"
									(change)="onPlusMinusGroupChanged(criteria.criteriaID, $event)"
									(click)="$event.stopPropagation()"
								>
									<md-button-toggle value="+">{{ rubric.gradeName }}+</md-button-toggle>
									<md-button-toggle value="base">{{ rubric.gradeName }}</md-button-toggle>
									<md-button-toggle value="-">{{ rubric.gradeName }}-</md-button-toggle>
								</md-button-group>
							} @else {
								<md-tag [type]="rubric.gradeColor">{{ rubric.gradeName }}</md-tag>
							}
							<div>{{ rubric.description }}</div>
						</div>
					}
				} @else {
					<span>Select a criteria to grade</span>
				}
			</div>
			<lb-divider></lb-divider>
			<div class="footer">
				<button md-button (click)="close()">Close</button>
				<button md-button-brand class="save-button" [disabled]="missingGrades().length > 0" (click)="save()">Save</button>
			</div>
		</div>
	</div>
</md-dialog>
